// Theme values extracted from globals.css (Tailwind 4 CSS-first configuration)
// These values are used by components that need programmatic access to theme colors

const theme = {
  colors: {
    primary: {
      50: '#fef3f2',
      100: '#fee4e2',
      200: '#fececa',
      300: '#fcaca5',
      400: '#f97b70',
      500: '#f05143',
      600: '#dd3526',
      700: '#ba281b',
      800: '#9a241a',
      900: '#450f0a',
      DEFAULT: '#e30613',
    },
    secondary: {
      50: '#f5f8fb',
      100: '#eaf1f7',
      200: '#d2e2ed',
      300: '#a9c8dc',
      400: '#7baac6',
      500: '#598eb2',
      600: '#467395',
      700: '#3a5d79',
      800: '#334e65',
      900: '#2e4356',
      DEFAULT: '#7baac6',
    },
    success: {
      50: '#f0fdf5',
      100: '#dcfce8',
      200: '#bbf7d1',
      300: '#86efad',
      400: '#4ade80',
      500: '#22c55e',
      600: '#16a34a',
      700: '#15803c',
      800: '#166533',
      900: '#14532b',
      DEFAULT: '#22c55e',
    },
    warning: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde58a',
      300: '#fbd24e',
      400: '#fbbf24',
      500: '#f59e0b',
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f',
      DEFAULT: '#f59e0b',
    },
    background: '#faf4f3',
    gray2: '#b6b1b1',
    itau: {
      primary: '#ff7200',
    },
    slate: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617',
    },
    zinc: {
      50: '#fafafa',
      100: '#f4f4f5',
      200: '#e4e4e7',
      300: '#d4d4d8',
      400: '#a1a1aa',
      500: '#71717a',
      600: '#52525b',
      700: '#3f3f46',
      800: '#27272a',
      900: '#18181b',
      950: '#09090b',
    },
  },
};

export default theme;
